__turbopack_context__.v({
  "container": "TechCard-module-scss-module__OwNa5a__container",
  "dark": "TechCard-module-scss-module__OwNa5a__dark",
  "gradient": "TechCard-module-scss-module__OwNa5a__gradient",
  "iconWrapper": "TechCard-module-scss-module__OwNa5a__iconWrapper",
  "name": "TechCard-module-scss-module__OwNa5a__name",
});
